// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".24c9c6b738c86ef749126f0f29cd633275f314d2.chunk.bundle.js";
};